import { motion } from "framer-motion";


const selfDesc = [
    `I currently work as an AI and Data Science Engineer at Deloitte, building agentic
    pipelines and automated insight-generation systems in the healthcare
    domain. My broader experience spans AI/ML engineering, big data analytics, and data
    engineering, including banking and risk analytics where accuracy, compliance, and
    system stability are essential.`,

    `I prefer working end to end across the lifecycle of data and AI systems: defining problem 
    requirements, architecting data workflows, developing and optimizing ML pipelines, 
    deploying solutions into production, and ensuring they remain maintainable and 
    technically sound.`,

    `Alongside my engineering work, I actively contribute to open-source and independent 
    projects across AI and data engineering. These include AI-assisted 
    data analysis tools, hybrid RAG + knowledge graph systems, generative AI applications, 
    gesture recognition frameworks, and Kubernetes-backed AI APIs. My goal has consistently 
    been to build practical, well-structured systems.`,

    `I also maintain a strong writing practice through technical blogging, where I document 
    concepts, simplify advanced topics, and share practical insights on data science, ML, 
    AI, and system design. Writing helps me stay grounded, think clearly, and 
    contribute back to the community in a meaningful way.`,

    `Outside work and research, I’m a chess enthusiast who enjoys strategy, pattern 
    recognition, and the kind of structured thinking that naturally aligns with 
    engineering problems.` 
  ];


function About() {

  const aboutContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12 }
    }
  };

  const paragraphVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };


  return (
    // <section id="about" className="min-h-screen bg-white text-gray-800 px-4 sm:px-6 py-16 flex items-center">
    <section
      id="about"
      name="about"
      className="bg-about min-h-screen bg-white text-gray-800 px-3 py-16">
      {/* <div className="max-w-6xl mx-auto"> */}
      <div className="site-container mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6 text-center">
          <u>About Me</u>
        </h2>

        <motion.div
          className="mt-1 space-y-2 text-justify"
          variants={aboutContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {selfDesc.map((text, i) => (
            <motion.p
              key={i}
              variants={paragraphVariant}
              transition={{ duration: 0.45 }}
            >
              {text}
            </motion.p>
          ))}
        </motion.div>

      </div>
    </section>
  );
}

export default About;
